import asyncComponent from '../common/utils/async-component.js';

const AgentNav = asyncComponent(async () => import('./components/agent-nav/index.js'));
const AgentDashboard = asyncComponent(async () => import('./components/agent-dashboard/index.js'));
const AgentSummary = asyncComponent(async () => import('./components/agent-summary/index.js'));
const Sessions = asyncComponent(async () => import('./components/sessions/index.js'));
const Messages = asyncComponent(async () => import('./components/messages/index.js'));
const AgentPreview = asyncComponent(async () => import('./components/agent-preview/index.js'));
const AgentTranscripts = asyncComponent(async () => import('./components/agent-transcripts/index.js'));
const AgentTranscriptCreate = asyncComponent(async () => import('./components/agent-transcript-create/index.js'));
const AgentTranscriptEdit = asyncComponent(async () => import('./components/agent-transcript-edit/index.js'));
const ContentNav = asyncComponent(async () => import('../common/components/nav/content-nav/index.js'));
const AgentEvals = asyncComponent(async () => import('./components/agent-evals/index.js'));

export default {
  '/agents': {
    components: { main: AgentDashboard, nav: AgentNav },

    '/:agentName': {
      components: { main: AgentSummary, nav: AgentNav },

      '/sessions': {
        components: { main: Sessions, nav: AgentNav },

        '/:sessionId': {
          components: { main: Messages, nav: AgentNav }
        }
      },

      '/preview': {
        components: { main: AgentPreview, nav: AgentNav }
      }
    }
  },
  '/transcripts': {
    components: { main: AgentTranscripts, nav: ContentNav },

    '/create': {
      components: { main: AgentTranscriptCreate, nav: ContentNav }
    },

    '/edit/:transcriptId': {
      components: { main: AgentTranscriptEdit, nav: ContentNav }
    }
  },
  '/evals': {
    components: { main: AgentEvals, nav: AgentNav }
  }
};
